import { app } from "api";
import { useMutation, useQuery, useQueryCache } from "react-query";

export function useServicesQuery() {
  const uid = app.auth().currentUser?.uid;
  return useQuery(["services"], () => {
    return app
      .firestore()
      .collection("labServices")
      .where("labId", "==", uid)
      .get()
      .then((res) => res.docs.map((i) => i.data()));
  });
}

export function useService(serviceId: string | undefined) {
  return useQuery([`services-${serviceId}`], () => {
    if (!serviceId) return;
    return app
      .firestore()
      .collection("labServices")
      .doc(serviceId)
      .get()
      .then((res) => res.data());
  });
}

export function useAddService() {
  const uid = app.auth().currentUser?.uid;
  const queryCache = useQueryCache();

  return useMutation(
    async (service: any) => {
      const labServiceRef = app.firestore().collection("labServices").doc();
      await labServiceRef.set({
        ...service,
        id: labServiceRef.id,
        enabled: true,
        labId: uid,
      });
    },
    {
      onSuccess: () => {
        queryCache.invalidateQueries(["services"]);
      },
    }
  );
}

export function useEditService() {
  const queryCache = useQueryCache();

  return useMutation(
    async (service: any) => {
      await app
        .firestore()
        .collection("labServices")
        .doc(service.id)
        .update(service);
    },
    {
      onSuccess: (data, variables) => {
        queryCache.setQueryData(["services"], (old: any) => {
          return old?.map((i: any) => (i.id === variables.id ? variables : i));
        });
        queryCache.invalidateQueries(["services"]);
      },
    }
  );
}
export function useDeleteService() {
  const queryCache = useQueryCache();

  return useMutation(
    async (serviceId: string) => {
      await app.firestore().collection("labServices").doc(serviceId).delete();
    },
    {
      onSuccess: (data, variable) => {
        queryCache.setQueryData(["services"], (old: any) => {
          return old?.filter((i: any) => i.id !== variable);
        });
        queryCache.invalidateQueries(["services"]);
      },
    }
  );
}
